// extracted by mini-css-extract-plugin
export default {"colouredRoundWrapper":"wrappers_colouredRoundWrapper__7ULoF","mainContentWrapper":"wrappers_mainContentWrapper__D70UN","mainSectionWrapper":"wrappers_mainSectionWrapper__oqNO6"};